import UpdateBiddingPriceBuyNowModal from "./UpdateBiddingPriceBuyNowModal";

export default UpdateBiddingPriceBuyNowModal;